import type { Domain } from '@gro-up/types'
import { inject, ref, type Ref } from 'vue'

export const useDomain = () => {
  const domain = inject<Ref<Domain | null>>('domain', ref(null))
  return domain
}
